// Public build contract shared with the production nginx renderer. No cookies,
// provider state, request headers or forwarded hosts can select the destination.
export const PRODUCTION_CRM_ORIGIN = 'https://app.connectgroove.com';
const legacyHosts = new Set(['leads.trevi.ca', 'craft2.manucraft3d.com']);
const providerCallbacks = new Set([
  '/auth/calendar/google/callback', '/auth/calendar/microsoft/callback',
  '/auth/mail/microsoft/callback', '/auth/email/exchange/callback', '/auth/email/exchange/relay',
]);
export function productionCrmCanonicalBuildEnabled(env) {
  return env.VITE_AUTH_MODE === 'auth0' && env.VITE_API_URL === PRODUCTION_CRM_ORIGIN &&
    env.VITE_API_BASE_URL === PRODUCTION_CRM_ORIGIN + '/api';
}
// Match the existing Craft-only BrowserRouter basename, with a segment boundary.
export function productionCrmLogicalPath(location) {
  return location.hostname === 'craft2.manucraft3d.com' && /^\/leads[.]trevi[.]ca(?:\/|$)/.test(location.pathname)
    ? location.pathname.slice('/leads.trevi.ca'.length) || '/' : location.pathname;
}
export function productionProviderCallback(env, location) {
  return productionCrmCanonicalBuildEnabled(env) && location.protocol === 'https:' &&
    (legacyHosts.has(location.hostname) || location.hostname === 'app.connectgroove.com') && providerCallbacks.has(productionCrmLogicalPath(location));
}
export function productionCrmNavigationTarget(env, location, topLevel) {
  if (!productionCrmCanonicalBuildEnabled(env) || !topLevel || location.protocol !== 'https:' || location.hostname !== 'craft2.manucraft3d.com') return null;
  const logicalPath = productionCrmLogicalPath(location);
  let path = logicalPath;
  try { path = decodeURIComponent(path); } catch { /* Preserve the original URL on navigation. */ }
  if (/^\/(?:api|socket[.]io|health|fastapi|auth|craft|survey|meeting|meeting-request|embed|public|[.]well-known)(?:\/|$)/.test(path) ||
      /[.](?:js|css|png|jpg|jpeg|gif|ico|svg|woff|woff2|ttf|eot|glb|gltf|json|map)$/.test(path)) return null;
  // Concatenate to a fixed origin: URL(path, origin) would interpret //evil as
  // an authority. Keep original escaping, query and hash without decoding them.
  if (!logicalPath.startsWith('/')) return null;
  return PRODUCTION_CRM_ORIGIN + logicalPath + location.search + location.hash;
}
